import React from "react";

const TableOptionsGaverBidrag = ({ index, handleChange }: any): JSX.Element => {
  return (
    <select
      className="outline-none truncate w-full  justify-content
                                            py-2 text-lg border border-sk-primary-blue font-medium rounded-md
                                            text-black hover:border-blue-500 focus:ring-2 focus:ring-blue-600 text-justify"
      id="alternativ"
      name="alternativ"
      onChange={(e) => handleChange(e, index)}
      value={index.alternativ}
    >
      <option value="Velg et alternativ her..">Velg et alternativ her..</option>
      <option value="N.K.S Veiledningssenter"> N.K.S Veiledningssenter</option>
      <option value="N.K.S Virksomheter"> N.K.S Virksomheter</option>
      <option value="Barn og unge i lokalmiljøet">
        {" "}
        Barn og unge i lokalmiljøet
      </option>
      <option value="Eldre"> Eldre</option>
      <option value="Krisesenter">Krisesenter</option>
      <option value="Annet">Annet</option>
    </select>
  );
};
export default TableOptionsGaverBidrag;
